<template>
  <SfModal
    v-if="modalOpen"
    content-class-name="sf-pad-3"
    size="xs"
    footer-align="center"
    @close="close"
  >
    <template #title>{{
      I18n.t('report/template.xlsx_export_modal.title')
    }}</template>

    <template #body>
      <p class="sf-below-3">
        {{ I18n.t('report/template.xlsx_export_modal.description') }}
      </p>
      <div class="sf-form-group">
        <label class="sf-form-check sf-level sf-below-2">
          <div class="sf-inline-block">
            <input
              v-model="expanded"
              type="radio"
              name="expand_all"
              :value="false"
              data-testid="xlsx-export-collapsed"
            /><span class="sf-form-check-content"
              ><span class="sf-form-check-indicator"></span
            ></span>
          </div>
          <div>
            <div>
              {{ I18n.t('report/template.xlsx_export_modal.collapsed') }}
            </div>
            <div class="sf-dim-el sf-font-s">
              {{ I18n.t('report/template.xlsx_export_modal.collapsed_hint') }}
            </div>
          </div>
        </label>
        <label class="sf-form-check sf-level">
          <div class="sf-inline-block">
            <input
              v-model="expanded"
              type="radio"
              name="expand_all"
              :value="true"
              data-testid="xlsx-export-expanded"
            /><span class="sf-form-check-content"
              ><span class="sf-form-check-indicator"></span
            ></span>
          </div>
          <div>
            <div>
              {{ I18n.t('report/template.xlsx_export_modal.expanded') }}
            </div>
            <div class="sf-dim-el sf-font-s">
              {{ I18n.t('report/template.xlsx_export_modal.expanded_hint') }}
            </div>
          </div>
        </label>
      </div>
    </template>

    <template #footer>
      <SfButtonDs variant="secondary" @click="close">
        {{ I18n.t('common.cancel') }}
      </SfButtonDs>
      <SfButtonDs variant="primary" @click="download">
        {{ I18n.t('report/template.xlsx_export_modal.download') }}
      </SfButtonDs>
    </template>
  </SfModal>
</template>

<script>
import { SfModal } from '@app/shared/vue/components/sf-modal'
import { SfButtonDs } from '@silverfin/ui-components'
import { getSafeJSONValue } from '@app/utils/local-storage'
import getPiniaInstance from '@app/shared/pinia/instance'

import { REPORTS_SETTING_KEY } from '../constants'
import { useColumnEditor } from '../column-editor/use-column-editor'

// Rack starts a new array element at the first key the previous one already
// holds, so each column's `type` has to come before its values. A null value
// goes as "" because URLSearchParams would send the string "null".
const appendColumns = (searchParams, columns) => {
  columns.forEach(({ type, values }) => {
    searchParams.append('columns[][type]', type)
    Object.entries(values).forEach(([name, value]) => {
      searchParams.append(`columns[][values][${name}]`, value ?? '')
    })
  })
}

export default {
  components: {
    SfModal,
    SfButtonDs,
  },

  data() {
    return {
      modalOpen: false,
      downloadUrl: '',
      expanded: false,
    }
  },

  methods: {
    // Called by modalCitizen.openModal with the trigger link's context. Mirrors
    // the on-screen expand state by reading the same per-report localStorage key
    // that report-table.js writes.
    openModal({ reportId, downloadUrl }) {
      this.downloadUrl = downloadUrl
      const settings =
        getSafeJSONValue(`${REPORTS_SETTING_KEY}-${reportId}`) || {}
      this.expanded = Boolean(settings.expanded)
      this.modalOpen = true
    },

    close() {
      this.modalOpen = false
    },

    download() {
      const url = new URL(this.downloadUrl, window.location.origin)
      if (this.expanded) {
        url.searchParams.set('expand_all', 'true')
      }

      const { appliedColumns } = useColumnEditor(getPiniaInstance())
      if (appliedColumns) {
        appendColumns(url.searchParams, appliedColumns)
      }

      // Full navigation (not Turbolinks) so the browser handles the file download.
      window.location.href = url.toString()
      this.close()
    },
  },
}
</script>
